import { Component } from '@angular/core';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-hub-button-nav',
  templateUrl: './hub-button-nav.component.html',
  styleUrls: ['./hub-button-nav.component.scss'],
})
export class HubButtonNav {
  productCode = ProductCode;
  isNavAtEnd: boolean = false;
  onNavScroll(event: Event): void {
    const el = event.target as HTMLElement;
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
    this.isNavAtEnd = atEnd;
  }
}
